import { Controller } from "@hotwired/stimulus"

// Manages calendar view switching (Day/Month/Year)
export default class extends Controller {
  static targets = ["monthView", "dayView", "yearView", "dayBtn", "monthBtn", "yearBtn", "monthNav"]
  
  connect() {
    this._switchHandler = (e) => {
      this.showMonth()

      if (e.detail?.queryString) {
        window.location.href = `${window.location.pathname}${e.detail.queryString}`
      }
    }

    this.element.addEventListener('calendar-year-view:switch-to-month', this._switchHandler)

    this.showMonth()
  }

  disconnect() {
    if (this._switchHandler) {
      this.element.removeEventListener('calendar-year-view:switch-to-month', this._switchHandler)
      this._switchHandler = null
    }
  }
  
  showDay() {
    try {
      this.hideAllViews()
      this.dayViewTarget.classList.remove('hidden')
      this.setActiveButton(this.dayBtnTarget)
      this.dispatch('view-changed', { detail: { view: 'day' } })
    } catch(e) {
      // Error showing day view - silently handle
    }
  }
  
  showMonth() {
    try {
      this.hideAllViews()
      this.monthViewTarget.classList.remove('hidden')
      // The month period nav lives in the shared header; reveal it for month view.
      if (this.hasMonthNavTarget) this.monthNavTarget.classList.remove('hidden')
      this.setActiveButton(this.monthBtnTarget)
      this.dispatch('view-changed', { detail: { view: 'month' } })
    } catch(e) {
      // Error showing month view - silently handle
    }
  }
  
  showYear() {
    try {
      this.hideAllViews()
      this.yearViewTarget.classList.remove('hidden')
      this.setActiveButton(this.yearBtnTarget)
      this.dispatch('view-changed', { detail: { view: 'year' } })
    } catch(e) {
      // Error showing year view - silently handle
    }
  }
  
  hideAllViews() {
    if (this.hasMonthViewTarget) this.monthViewTarget.classList.add('hidden')
    if (this.hasDayViewTarget) this.dayViewTarget.classList.add('hidden')
    if (this.hasYearViewTarget) this.yearViewTarget.classList.add('hidden')
    // Day/Year views carry their own period nav inside their containers, so the
    // shared month nav hides unless month view re-shows it.
    if (this.hasMonthNavTarget) this.monthNavTarget.classList.add('hidden')
  }
  
  setActiveButton(activeBtn) {
    // .is-active is styled by .bz-cal-seg__btn in design-system/calendar.css.
    [this.dayBtnTarget, this.monthBtnTarget, this.yearBtnTarget].forEach(btn => {
      btn.classList.toggle('is-active', btn === activeBtn)
    })
  }
}

